import { ToastStateHandler, UserApi } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpDeleteUser = () => {
    const { t } = useTranslation('newNotifications');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = (userSub: string, callback: ICallback) => {
        const { exec, abort } = userApi.deleteUser({
            params: { userSub },
            onSuccess: () => {
                if (callback.onSuccess) callback.onSuccess();
                toastHandler.push('success', t('user.deleteTitle'), t('user.deleteSuccess'));
            },
            onError: error => {
                if (callback.onError) callback.onError(error);
                else toastHandler.push('error', t('user.deleteTitle'), t('user.deleteError'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpDeleteUser;
